import { Heart } from "lucide-react";
import { useFavorites } from "@/context/FavoritesContext";
import { toast } from "sonner";

export const FavoriteButton = ({ launch, className = "" }) => {
  const { isFavorite, toggleFavorite } = useFavorites();
  const favorited = isFavorite(launch.id);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const added = toggleFavorite(launch);
    if (added) {
      toast.success("Added to watchlist!");
    } else {
      toast.info("Removed from watchlist");
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`p-2 rounded-lg border ${
        favorited 
          ? "bg-ignition-red/20 border-ignition-red/30 text-ignition-red" 
          : "bg-white/5 hover:bg-white/10 border-white/10 text-slate-400"
      } ${className}`}
      title={favorited ? "Remove from watchlist" : "Add to watchlist"}
      data-testid={`favorite-btn-${launch.id}`}
      style={{ transition: "all 0.2s ease" }}
    >
      <Heart 
        className="w-4 h-4" 
        strokeWidth={1.5}
        fill={favorited ? "currentColor" : "none"}
      />
    </button>
  );
};
